export default __webpack_public_path__ + "static/media/calendar-of-events.12e7362f.svg";